function implicitLoginPopup() {
  function onClick(e) {
    if (e) {
      e.preventDefault()
    }

    cphPopup("/IdpImplicitFlow/Login", "xtf", "470", "675")

    e.stopPropagation()
  }

  function cphPopup(url, title, w, h) {
    // Fixes dual-screen position
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top

    const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
    const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height

    const left = width / 2 - w / 2 + dualScreenLeft
    const top = height / 2 - h / 2 + dualScreenTop

    const newWindow = window.open(
      url,
      title,
      "titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=no,width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left,
    )

    // Puts focus on the CPH IDP upon initiating
    if (window.focus) {
      newWindow.focus()
    }
  }

  const openBtn = document.querySelector(".site-login")
  openBtn?.addEventListener("click", onClick)

  const logoutBtn = document.querySelector(".site-logout")
  logoutBtn?.addEventListener("click", function (e) {
    if (e) {
      e.preventDefault()
    }

    window.location.href = "/IdpImplicitFlow/Logout"
  })
}

if (document.readyState !== "loading") {
  implicitLoginPopup()
} else {
  document.addEventListener("DOMContentLoaded", implicitLoginPopup)
}
